<template>
  <div class="pg-share" :class="star" ref="share">
    <div class="pg-header"></div>
    <!-- <div class="pg-bottom"></div> -->
    <!-- <div :class="star" class="name" v-show="star !== 'boss'"></div> -->
    <div class="logo"></div>
    <div class="slogan" :class="star"></div>
    <div class="scroll-wrapper" :class="star">
      <div class="scroll" :class="star">
        <div>{{nickname}}</div>
      </div>
    </div>
    <div class="friend" :class="star">
      <div class="prize-wrapper" :class="star">
        <Prize
          v-for="(prize, index) in myPrize"
          :key="index"
          :prize="prize.icon"
          :name="prize.title"
        >
        </Prize>
      </div>
    </div>
    <!-- <div class="human"></div> -->
    <div v-if="showHelp" class="help" :class="star" @click="help"></div>
    <div v-else class="draw" :class="star" @click="goHome"></div>
    <a v-if="!ingame" class="btn-download ios" :class="star" @click="iosHandler"></a>
    <a class="btn-download android" :class="star" @click="downloadHandler"></a>
  </div>
</template>
<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Prize from "~/components/Prize/index.vue";
import { isWeiXin, getParameterByName, isAndroid, setCookie, getCookie, deleteCookie } from "~/tools/utils";
import api from "~/api/api";
import { mapState } from "vuex";
import Alert from "~/components/Alert";
import Help from "~/components/Help";

export default {
  components: {Prize},
  data() {
    return {
      mtag: getParameterByName('mtag'),
      star: 'zhounian',
      isAndroid: isAndroid(),
      myPrize: [],
      fid: getParameterByName("fid"),
      wxtitle: "《原始征途》嘉年华至尊百连抽",
      wxdesc: `免费抽终极豪礼，时装坐骑任选，更有专属锦鲤大奖！`,
      wximages: "https://" + window.location.host + "/act/blc_carnival2024/share.jpg",
      loading: false,
      nickname: '',
      invite_state: 0,
      help_state: 0,
      help_count: 0,
      ingame: getParameterByName("ingame")
    }
  },
  mounted() {
    // TODO 测试助力弹窗 需去掉
    // Help("助力成功！<br>你也去抽个十连试试手气吧！").then(() => {
    //   this.$router.push('/index')
    // });

    const _this = this;
    var appid = 'wx0fcf7f47419c8171';

    if(window.innerHeight*750 < 1388*window.innerWidth) {
      this.$refs.share.style.height = '14.98rem'
    }

    requirejs(["weixin/main", "downloadway/main", "jquery"],function(weixin, Download, $){
    // requirejs(["downloadway/main", "jquery"],function(Download, $){
      Promise.all([
        api.getUserInfo(),
        api.getFriendPrize(_this.fid)
      ]).then(res => {
        if(res[1] && res[1].status === 1) {
          try {
            _this.nickname = _this.getChineseChar(res[1].nickname); //
            _this.invite_state = res[1].invite_state
            _this.help_state = res[1].help_state
            if(_this.help_state === 1) {
              Alert("您已为该好友进行过助力，<br>还可以助力其他好友！");
            }
            if(res[1].data.item_detail && res[1].data.item_detail.some(x => x.icon === 31)) {
              res[1].data.item_detail = res[1].data.item_detail.slice(0, 9);
            }
            _this.myPrize = res[1].data.item_detail || [];
          } catch (error) {
            console.log('no prize')
          }
        }
        if(res[0].status === 1) {
          store.commit(types.UPDATE_USER, res[0]);
          _this.help_count = res[0].help_count || 0
          if(res[0].shareinfo.userid !== parseInt(_this.fid)) {
            if(_this.help_count === 5 && _this.help_state !== 1) {
              Alert("你的助力次数已满，<br>快去召集更多好友百连抽吧");
            }
          }
          if(res[0].weixin_state) {
            window.wx = new weixin(appid,() => {
              let link = window.location.origin + `/act/blc_carnival2024/#/share?fid=${res[0].shareinfo.userid}`
              if(_this.mtag) {
                link += `&mtag=${_this.mtag}`
              }
              //朋友圈
              wx.onMenuShareTimeline({
                  title: `${res[0].shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                  link, // 分享链接
                  imgUrl: _this.wximages
              });
              //朋友
              wx.onMenuShareAppMessage({
                  title: `${res[0].shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                  desc: _this.wxdesc, // 分享描述
                  link, // 分享链接
                  imgUrl: _this.wximages, // 分享图标
                  type: 'link' // 分享类型,music、video或link，不填默认为link
              });
              if(_this.ingame) {
                window.wx.miniProgram.postMessage({data: { fid: res.shareinfo.userid, star: _this.star }});
              }
            });
          } else {
            window.wx = new weixin(appid,() => {
              //朋友圈
              wx.onMenuShareTimeline({
                  title: `${res[0].shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                  link: window.location.href, // 分享链接
                  imgUrl: _this.wximages
              });
              //朋友
              wx.onMenuShareAppMessage({
                  title: `${res[0].shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                  desc: _this.wxdesc, // 分享描述
                  link: window.location.href, // 分享链接
                  imgUrl: _this.wximages, // 分享图标
                  type: 'link' // 分享类型,music、video或link，不填默认为link
              });
            });
          }
          // TODO 需去掉注释
          if(res[0].shareinfo.userid === parseInt(_this.fid)) {
            window.location.replace(location.origin + location.pathname + `#/index`);
            return;
          }
        }
        document.querySelector(".pg-loading").style.display = "none";
        let gotoHelp = getCookie('toHelp');
        if(gotoHelp) {
          _this.help();
        }
      });
      if(!_this.ingame) {
        new Download({
          iosBtn: $(".ios"),
            androidBtn: $(".android"),
          display: "block",
          tip: "iOS版本敬请期待",
          callback: function (info) {},
        });
      }
    });
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    showHelp() {
      return !this.invite_state && !this.help_state && this.help_count < 5
    }
  },
  methods: {
    iosHandler() {
      _paq.push(['trackEvent', 'BLC-Download', 'Share', 'ios', 'ios'])
    },
    downloadHandler() {
      let platform = this.isAndroid ? 'android' : 'ios'
      _paq.push(['trackEvent', 'BLC-Download', 'Share', platform, platform])
      if(this.ingame) {
        let url = `https://yszt.ztgame.com/download/${platform}.html`
        store.commit(types.SHOW_MODAL, {type: 'copy', copy: url})
      }
    },
    checkLoginStatus() {
      if(!this.userInfo.weixin_state) {
        setCookie('toHelp', 'toHelp');
        let url = `/act/blc_carnival2024/api/api.php?c=index&a=wxauth&fid=${this.fid}`
        if(this.mtag) {
          url += `&mtag=${this.mtag}`
        }
        if(/web.ztgame.com/.test(location.href)) {
          url = `https://yszt.web.ztgame.com/act/blc_carnival2024/api/api.php?c=index&a=wxauth&fid=${this.fid}`
          if(this.mtag) {
            url += `&mtag=${this.mtag}`
          }
        }
        if(this.ingame) {
          url += '&ingame=ingame'
        }
        location.replace(url)
        return false;
      }
      return true
    },
    help() {
      if(!this.checkLoginStatus()) {
        return
      }
      if(this.loading) {
        return
      }
      store.commit(types.SHOW_LOADING, true)
      this.loading = true;
      api.helpFriend(this.fid, this.userInfo.shareinfo.userid).then(res => {
        if(res.status === 1) {
          Help("助力成功！<br>你也去抽个十连试试手气吧！").then(() => {
            if(_paq) {
              _paq.push(['trackEvent', 'yszt-blc-share', `draw-by-${this.mtag || 'gaoye'}`])
            }
            window.location.replace(location.origin + location.pathname + `#/index`)
          });
        }
        deleteCookie('toHelp')
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      }).catch(() => {
        deleteCookie('toHelp')
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      })
    },
    getChineseChar(value) {
      var l = 0;
      let output = ''
      if (value) {
        Array.from({ length: value.length }, (v, i) => {
          if (/[\u4e00-\u9fa5]/.test(value[i])) {
            l += 2;
          } else {
            l += 1;
          }
        });
      }
      if(this.star === 'gaoye') {
        if(l > 15) {
          l = 0;
          Array.from({ length: value.length }, (v, i) => {
            if (/[\u4e00-\u9fa5]/.test(value[i])) {
              l += 2;
            } else {
              l += 1;
            }
            if(l <= 12) {
              output += value[i]
            }
          });
          output += '...'
        } else {
          output = value.substr(0, 15)
        }
      } else {
        if(l > 14) {
          l = 0;
          Array.from({ length: value.length }, (v, i) => {
            if (/[\u4e00-\u9fa5]/.test(value[i])) {
              l += 2;
            } else {
              l += 1;
            }
            if(l <= 11) {
              output += value[i]
            }
          });
          output += '...'
        } else {
          output = value.substr(0, 14)
        }
      }
      return output;
    },
    goHome() {
      // this.$router.push('/index')
      if(_paq) {
        _paq.push(['trackEvent', 'yszt-blc-share', `draw-by-${this.mtag || 'gaoye'}`])
      }
      window.location.replace(location.origin + location.pathname + `#/index`)
    },
  }
}
</script>

<style lang="stylus" scoped>
  .pg-share
    width 100%
    min-height 100vh
    background url('./images/repeat.jpg') repeat
    position relative
    .pg-header
      position absolute
      top 0
      width 100%
      height 16.26rem
      background-image: url('./images/friend-bg.jpg')
      background-size: 100% 100%
    .pg-bottom
      position absolute
      bottom: 0
      width 100%
      height 4.43rem
      // background-image: url('./images/share-bottom.png')
      background-size: 100% 100%
    .prize-wrapper
      margin 1.46rem 0 0 0.64rem;
      display flex
      flex-wrap wrap
      &.lv
        margin-left 0.5rem
    .logo
      position absolute
      top 0.07rem
      left 6.26rem
      width 1.22rem
      height 1.15rem
      background:url(./images/jnh/logo.png) no-repeat;
      background-size contain
    .slogan
      position absolute
      top 5.7rem
      left 1.2rem
      width 5.22rem
      height 1.65rem
      background:url(./images/friend-slogan.png) no-repeat;
      background-size contain
    .name
      position absolute
      top 3.3rem
      left 0.64rem
      width 0.66rem
      height 1.38rem
      background:url(./images/gaoye/friend-name.png) no-repeat;
      background-size contain
      animation slideInLeft 1s ease
    .scroll-wrapper
      position absolute
      top 4.74rem
      left 1.73rem
      width 4.03rem
      height 1.08rem
      .scroll
        width 4.03rem
        height 1.08rem
        font-size 0.26rem
        text-align center
        letter-spacing 0.01rem
        font-weight bold
        word-break break-all
        // display flex
        // flex-direction column
        // justify-content center
        align-items center
        padding: 0 0.2rem
        line-height 1.12rem
        color #fff978
        background-image: url(./images/jnh/share-frame.png)
        background-size 100% 100%
        background-position center center
      .slogan
        position absolute
        bottom 0
        left 0.29rem
        width 5.22rem
        height 1.65rem
        background:url(./images/friend-slogan.png) no-repeat;
        background-size contain
        animation slideInRight 0.6s ease
    .human
      position absolute
      top 0.16rem
      left 3.28rem
      width 4.22rem
      height 5.47rem
      background:url(./images/human.png) no-repeat;
      background-size contain
    .friend
      position absolute
      top 7.7rem
      left 0.22rem
      width 7.13rem
      height 5.66rem
      background:url(./images/friend-prize.png) no-repeat;
      background-size contain
    .help
      position absolute
      top 7.39rem
      left 50%
      width 3.41rem
      margin-left -1.705rem
      height 1.16rem
      background:url(./images/help.png) no-repeat;
      background-size contain
      animation: shake 2.4s both infinite;
    .draw
      position absolute
      left 50%
      top 7.39rem
      width 3.41rem
      margin-left -1.705rem
      height 1.16rem
      background:url(./images/me.png) no-repeat;
      background-size contain
      animation: shake 2.4s both infinite;
      &.lv
        top 7.29rem
    .btn-download
      position absolute
      top 13.62rem
      left 50%
      margin-left -1.325rem
      width 2.65rem
      height 0.7rem
      background:url(./images/download2.png) no-repeat;
      background-size contain
      &.lv
        top 13.18rem
@keyframes rotate {
  to {
    transform: rotateY(360deg)
  }
}
@keyframes rotate {
  to {
    transform: rotateY(360deg)
  }
}
@keyframes slideInRight {
  0% {
    opacity: 0
    transform: translateX(100%)
  }

  100% {
    opacity: 1
    transform: translateX(0)
  }
}

@keyframes shake {
  5%,
  10% {
    transform: scale(0.9) rotate(-3deg);
  }

  15%,
  25%,
  35%,
  45% {
    transform: scale(1.1) rotate(3deg);
  }

  20%,
  30%,
  40% {
    transform: scale(1.1) rotate(-3deg);
  }

  50% {
    transform: scale(1) rotate(0);
  }
}
</style>
